import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import { Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { STORAGE } from "../../constant/storages";
import { ApiserviceService } from "../../httpservice/apiservice.service";
import { _getStorage } from "../../utils/local-storage";
import { DateFormat } from "./setdate";

@Component({
  selector: "app-report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.scss"],
  providers: [{ provide: DateAdapter, useClass: DateFormat }],
})
export class ReportComponent implements OnInit {
  foods = [{ id: "0", value: "ออกเอกสารอิเล็กทรอนิกส์" }];

  ROLE: string = "";
  showall = false;
  showseltall = false;
  selfall = "";
  alls = "all";
  valueStorageid: any;
  showbtn = false;

  taxList = [
    { id: "001", value: "ใบกำกับภาษีเต็มรูป ออกแทนใบกำกับภาษีอย่างย่อ" },
    // { id: "002", value: "ใบทดแทน" },
    { id: "002", value: "ใบลดหนี้" },
    { id: "003", value: "ใบลดหนี้คงค้าง" },
  ];
  datastore = [];
  datastores = [];
  All = "all";
  storeid = "";
  storebu = "";
  formReport: FormGroup;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    private builder: FormBuilder,
    private alertController: AlertController,
    private router: Router,
    private dateAdapter: DateAdapter<Date>,
    public apiservice: ApiserviceService
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.initialCreateFomrReport();
    dateAdapter.setLocale("en-GB");
  }

  async ngOnInit() {
    let bu: any = {};
    if (this.userRole === "ETAXSUPERADMIN") {
      bu = { bu: "all" };
    } else {
      bu = { bu: this.userBu };
    }
    const bodyEncrypt = await this.apiservice.encryptBody(bu);
    const bodyReq = await this.apiservice.setBase64(bodyEncrypt);

    this.apiservice
      ._get(
        this.apiservice.apiUrl +
          this.apiservice.getListLocation +
          `api=${bodyReq}`
      )
      .then(async (res: any) => {
        console.log("res get stor id =====:: ", res);
        if (res.statusCode === 200) {
          let groupDataStore = [];
          let location = res.data.location;
          let alls = {
            bu: "all",
            seller_branch_name: "",
            seller_name: "",
            seller_storeid: "00000",
          };
          if (this.showall) {
            groupDataStore.push(...location, alls);
          } else {
            groupDataStore.push(...location);
          }

          this.datastore = groupDataStore
            .map((m) => ({
              ...m,
              seller_storeid: m.seller_storeid,
            }))
            .sort((a, b) => (a.seller_storeid > b.seller_storeid ? 1 : -1));
          console.log("this.datastore", this.datastore);
          this.datastores = this.datastore;
          this.storeid = this.datastore[0];
          this.storebu = this.datastore[0].bu;

          await this.initialCreateFomrReport();
        } else if (res.statusCode === 204) {
          const alert = await this.alertController.create({
            cssClass: "my-custom-class",
            message: res.statusMessage,
            buttons: [
              {
                text: "OK",
                cssClass: "alertButton",
                handler: async (blah) => {
                  await this.initialCreateFomrReport();
                },
              },
            ],
          });
          await alert.present();
        }
      });
  }

  async ionViewDidEnter() {
    this.ROLE =
      this.userRole.indexOf("ADMIN") > -1
        ? "ADMIN"
        : this.userRole.indexOf("USER") > -1
        ? "USER"
        : "NONE";

    this.showall =
      this.userRole === "ETAXSUPERADMIN" ||
      this.userRole === "SUPERADMIN" ||
      this.userRole === "ADMINEDIT" ||
      this.userRole === "ADMINCONFIG"
        ? true
        : false;

    if (this.userRole === "USERFEATURE") {
      this.showseltall = false;
    } else {
      this.showseltall = true;
    }
  }
  loadstorage() {
    this.valueStorageid = "";
    this.showbtn = false;
    this.datastore = this.datastores;
  }

  storeBu(e) {
    console.log(e);
    this.formReport.controls["storebu"].setValue(e.value.bu);
  }

  checkvalueall = true;
  searchstoreid(search) {
    let val: string = search;
    this.valueStorageid = val;

    if (val.trim() !== "") {
      this.datastore = this.datastores.filter((item) => {
        return (
          item.seller_storeid.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.seller_branch_name.toLowerCase().indexOf(val.toLowerCase()) >
            -1 ||
          item.seller_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });

      if (this.datastore.length > 0) {
        this.showbtn = false;
      } else {
        this.showbtn = true;
      }
    }

    this.datastore = val === "" ? this.datastores : this.datastore;
  }

  initialCreateFomrReport() {
    this.formReport = this.builder.group({
      report: ["ออกเอกสารอิเล็กทรอนิกส์", Validators.required],
      category: ["001", Validators.required],
      storeid: [this.storeid, Validators.required],
      storebu: [this.storebu],
      scope: ["all", Validators.required],
      reprotDateStart: [new Date(), [Validators.required]],
      reprotDateTo: [new Date(), [Validators.required]],
      reportdatecn: [new Date(), [Validators.required]],
    });
  }

  today: any;
  onChangeEventDateStart(e) {
    const checkData: Date = e.target.value;
    const thisDate = new Date();
    if (
      checkData.getFullYear() >= thisDate.getFullYear() &&
      checkData.getMonth() >= thisDate.getMonth() &&
      checkData.getDate() >= thisDate.getDate()
    ) {
      this.formReport.controls["reprotDateStart"].setValue(new Date());
    }
  }

  onChangeEventDateTo(e) {
    const checkData: Date = e.target.value;
    const thisDate = new Date();
    if (
      checkData.getFullYear() >= thisDate.getFullYear() &&
      checkData.getMonth() >= thisDate.getMonth() &&
      checkData.getDate() >= thisDate.getDate()
    ) {
      let date = new Date();
      date.setHours(0, 0, 0, 0);
      this.formReport.controls["reprotDateTo"].setValue(date);
    }
  }
  onSubmit() {
    if (this.formReport.invalid) return;
    console.log("this.formReport.value", this.formReport.value);
    const navigationExtras = {
      queryParams: {
        formReport: JSON.stringify(this.formReport.value),
      },
    };
    this.router.navigate(["report-document"], navigationExtras);
  }
  padnumber(data: String) {
    if (data === "00000") {
      return "all";
    } else {
      return data.padStart(5, "0");
    }
  }
  showdataCN = false;
  showallCN = true;
  checkcategory(data) {
    this.showdataCN = data === "003" ? true : false;
    // this.showallCN = data === "003" ? false : true;
  }
}
